import AboutIntro from './AboutIntro';

export default function AboutContent() {
  return (
    <div className='space-above'>
      <AboutIntro />
    </div>
  );
}

